import React from 'react';
import { Layout } from 'app/components/base/Layout';
import DataField from '../commons/DataField';
import Calendar from '../commons/Calendar';
import Step from 'app/components/search-results/Trip/commons/Step';
import { Arrow } from 'app/components/base/TripIcons';
import { FormattedMessage } from 'translations';
import { HOUR_FORMAT } from 'app/utils/types';
import InlineLabel from 'app/components/base/InlineLabel';
import moment from 'moment';

import style from './style.css';

const messages = {
  milesDistance: { id: 'SEARCH_RESULTS.MILES_DISTANCE' }
};

const Segment = ({
  showDateTimes,
  showTripTime,
  datetime,
  color,
  address,
  labelPrefix,
  labelMessage,
  distance,
  station,
  showWalkingStep,
  flightCode
}) => {
  // display either station (train, bus) or just address entered by user
  const displayLocation = (station && station.name) || address;

  return (
    <div className={style.field}>
      {showDateTimes && (
        <Layout
          nowrap
          align="start start"
          className={style.calendar}
        >
          <Calendar
            date={datetime}
            bgColor={color}
          />
          <div>
            <DataField
              value={address}
              labelPrefix={labelPrefix}
              labelPrefixColor={color}
              label={labelMessage}
            />
            {showTripTime && (
              <InlineLabel
                icon={{ name: "clock", family: "mozio" }}
                className={style['segment-info-label']}
                text={moment(datetime).format(HOUR_FORMAT)}
                iconColor={color}
              />
            )}
            {!!flightCode && (
              <InlineLabel
                icon={{ name: "airport", family: "mozio" }}
                className={style['segment-info-label']}
                text={flightCode}
                iconColor={color}
              />
            )}
          </div>
        </Layout>
      )}
      {!showDateTimes && (
        <DataField
          value={displayLocation}
          labelPrefix={labelPrefix}
          labelPrefixColor={color}
          label={labelMessage}
        />
      )}
      {showWalkingStep && !!distance && !!station && (
        <Layout
          align="start center"
          className={style['step-wrapper']}
        >
          <Step
            icon="walk"
            description={<FormattedMessage {...messages.milesDistance} values={{ distance }} />}
            className={style.step}
          />
          <span className={style.arrow}> <Arrow /> </span>
          {address || station.address}
        </Layout>
      )}
    </div>
  );
};

// TODO: move to Flow types
// Segment.propTypes = {
//   showDateTimes: PropTypes.string,
//   datetime: PropTypes.string,
//   color: PropTypes.string,
//   address: PropTypes.string,
//   labelPrefix: PropTypes.string,
//   labelMessage: PropTypes.string,
//   distance: PropTypes.string,
//   station: PropTypes.shape({
//     name: PropTypes.string,
//     address: PropTypes.string
//   }),
//   showWalkingStep: PropTypes.bool
// };

Segment.defaultProps = {
  showWalkingStep: false
};

export default Segment;
